import Head from 'next/head';
import Image from 'next/image';
import headerImgFull from '../public/images/siccro-fensterservice.jpg';
import headerImgMobile from '../public/images/siccro-fensterservice-mobile.jpg';
import { useWindowSize } from 'react-use';
import Link from 'next/link';
import TextSwitcher from 'components/shared/TextSwitcher';

import { MdFormatQuote } from 'react-icons/md/index';
import { FiMail } from 'react-icons/fi/index';
import { BsTelephone } from 'react-icons/bs/index';
import { FaFacebookSquare } from 'react-icons/fa/index';
import { FaInstagram } from 'react-icons/fa/index';

import functionImage1 from '../public/images/SICCRO-So-funktionierts-1.jpg';
import functionImage2 from '../public/images/SICCRO-So-funktionierts-2.jpg';
import functionImage3 from '../public/images/SICCRO-So-funktionierts-3.jpg';
import functionImage4 from '../public/images/SICCRO-So-funktionierts-4.jpg';
import karte from '../public/images/Österreichkarte.png';

import serviceImage1 from '../public/images/Leistungen_Pflege.jpg';
import serviceImage2 from '../public/images/Leistungen_Service.jpg';
import serviceImage3 from '../public/images/Leistungen_Reinigung.jpg';

import stock from '../public/images/STOCK.jpeg';
import gutImage from '../public/images/Gut_fuer_dich.png';
import siccro from '../public/images/SICCRO_Thumbnail.svg';
import { NavBar } from 'components/shared/NavBar';

const Page = () => {
	const { width } = useWindowSize();
	return (
		<>
			<Head>
				<meta name="viewport" content="width=device-width, initial-scale=1" />
				<title>Reinigung, Service & Pflege für Fenster, Türen & Sonnenschutz</title>
				<meta
					key="og:title"
					property="og:title"
					content="Reinigung, Service & Pflege für Fenster, Türen & Sonnenschutz"
				/>
				<meta
					key="twitter:title"
					property="twitter:title"
					content="Reinigung, Service & Pflege für Fenster, Türen & Sonnenschutz"
				/>
				<meta name="description" content="Reinigung, Service & Pflege für Fenster, Türen & Sonnenschutz" />
			</Head>
			<NavBar />
			<div className="mt-14">
				<section className="relative h-screen flex justify-center max-h-[650px] md:max-h-full">
					<Image src={width > 768 ? headerImgFull : headerImgMobile} objectFit="cover" layout="fill" />
					<div className="z-40 mt-16 md:mt-48 px-3 text-center space-y-9 items-center flex flex-col">
						<h1 className="font-sub text-4xl md:text-5xl font-light flex flex-col md:flex-row items-baseline">
							Wir sparen Ihnen <TextSwitcher textList={['Zeit', 'Stress', 'Geld']} interval={2000} />
						</h1>
						<div className="w-full mx-auto flex flex-col items-center">
							<p className="font-sub font-bold text-base md:text-lg">
								Reinigung, Pflege und Service für
								<br />
								Fenster, Türen und Sonnenschutz
								<br />
								<div className="text-2xl pt-5">
									ABO ab
									<span className="text-4xl"> €4,70</span>
									<a>/ Woche</a>
								</div>
							</p>
							<div className="">
								<Link href="/angebot" passHref>
									<button className="mt-9 w-30  select-none font-heading bg-primary p-3 rounded-md text-white text-lg shadow-md hover:shadow-lg hover:bg-primary-light focus:shadow-sm focus:outline-none active:shadow-inner transition-all active:bg-primary-dark duration-150">
										JETZT ANGEBOT EINHOLEN
									</button>
								</Link>
							</div>
							{/* <Link href="/config/category" passHref>
								<button className="invisible md:visible w-30 md:w-3/5 bg-white md:bg-transparent rounded-md md:rounded-none select-none font-heading md:shadow-none shadow-xl mt-1 md:mt-4 no-underline md:underline text-primary p-3 text-lg md:text-xl hover:text-primary-light transition-all duration-150">
									Angebot erstellen
								</button>
							</Link> */}
						</div>
					</div>
				</section>
			</div>
			<div className="max-w-[900px] flex flex-col items-center mx-auto mt-14 relative h-96">
				<iframe
					src="https://player.vimeo.com/video/667148540?h=0f424b3025&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
					allow="autoplay; fullscreen; picture-in-picture"
					style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
					title="SICCRO active service"
				></iframe>
			</div>
			<script src="https://player.vimeo.com/api/player.js"></script>
			<section className="container mx-auto">
				<h2 className="text-center font-heading font-medium text-3xl md:text-5xl py-9">So funktioniert´s</h2>

				<div className="flex flex-col md:flex-row">
					<div className="w-full md:w-1/4 p-3">
						<h3 className="text-center font-heading text-lg py-3">DIENSTLEISTUNG WÄHLEN</h3>
						<Link href="/angebot" passHref>
							<a className="hover:text-black">
								<Image src={functionImage1} />
								<h3 className="text-center font-heading font-semibold text-2xl py-3">
									1. Angebot konfigurieren
								</h3>
								<p className="text-center font-sub text-sm">
									Wählen Sie im Online Konfigurator die gewünschten Dienstleistungen und die Anzahl
									Ihrer Fenster, Türen und Sonnenschutz aus. In nur wenigen Minuten ist Ihr Angebot
									erstellt.
									{/* Gib uns Deine Kontaktdaten bekannt und wähle die gewünschte Uhrzeit an der wir dich
									am besten erreichen können. Die Anfrage ist kostenfrei und unverbindlich! */}
								</p>
							</a>
						</Link>
					</div>
					<div className="w-full md:w-1/4 p-3">
						<h3 className="text-center font-heading text-lg py-3">TERMIN & LAUFZEIT WÄHLEN</h3>
						<Image src={functionImage2} />
						<h3 className="text-center font-heading font-semibold text-2xl py-3">2. Termin auswählen</h3>
						<p className="text-center font-sub text-sm">
							Wählen Sie Ihren Wunschtermin und die Laufzeit aus. Sie haben die Möglichkeit zwischen 12,
							24 oder 48 Monate zu wählen.
							{/* Einer unserer netten Mitarbeiter wird sich mit Dir in verbindung setzen um Deinen Bedarf zu
							ermitteln und zusätzliche Informationen zu erhalten. */}
						</p>
					</div>
					<div className="w-full md:w-1/4 p-3">
						<h3 className="text-center font-heading  text-lg py-3">BIS 40% RABATT ERHALTEN</h3>
						<Image src={functionImage3} />
						<h3 className="text-center font-heading font-semibold text-2xl py-3">3. Online bezahlen</h3>
						<p className="text-center font-sub text-sm">
							Mit Abo bis zu 40% sparen und bequem über Kreditkarte oder SEPA - Überweisung bezahlen.
							{/* Wähle Deinen Wunschtermin aus, an dem Du unsere Dienstleistung erhalten möchtest. Du kannst
							diesen Termin jederzeit im Kundenportal ändern. */}
						</p>
					</div>
					<div className="w-full md:w-1/4 p-3">
						<h3 className="text-center font-heading  text-lg py-3">SICCRO GENIESSEN</h3>
						<Image src={functionImage4} />
						<h3 className="text-center font-heading font-semibold text-2xl py-3">4. Service genießen</h3>
						<p className="text-center font-sub text-sm">
							Das SICCRO Service Team kommt plus / minus 2 Minuten zu Ihnen nach Hause. Genießen Sie
							Pünktlichkeit, Verlässlichkeit und strahlend saubere, gepflegte und top gewartete Fenster,
							Türen und Sonnenschutz.
						</p>
					</div>
				</div>
				<div className="mx-auto flex justify-center">
					<Link href="/angebot" passHref>
						<button className="mt-9 w-1/2 md:w-1/6 select-none font-heading bg-primary p-3 rounded-md text-white text-lg shadow-md hover:shadow-lg hover:bg-primary-light focus:shadow-sm focus:outline-none active:shadow-inner transition-all active:bg-primary-dark duration-150">
							JETZT ANGEBOT EINHOLEN
						</button>
					</Link>
				</div>
			</section>
			<section className="container mx-auto mt-12">
				<h2 className="text-center font-heading font-medium text-5xl py-9">
					Gut für <span className="font-black">Sie</span>,<br /> die{' '}
					<span className="font-black">Menschen</span>
					<br /> und Ihren <span className="font-black">Geldbeutel</span>
				</h2>
				<div className="flex flex-col md:flex-row relative md:space-x-12 mt-12 px-3">
					<div className="w-full md:w-1/2 h-96 relative">
						<Image src={gutImage} layout="fill" objectFit="cover" />
					</div>
					<div className="flex flex-col justify-between w-full md:w-1/2 space-y-6 md:space-y-0 mt-6 md:mt-0">
						<div className="w-full md:w-2/3 text-center md:text-left">
							<h3 className="font-heading font-medium text-2xl pb-1">Regionale Service-Teams</h3>
							<p className="font-sub text-sm">
								Österreichweit mit mehr als 400 Service Teams. Damit bieten wir flächendeckend
								Reinigung, Pflege und Service für Fenster, Türen und Sonnenschutz.
							</p>
						</div>
						<div className="w-full md:w-2/3 text-center md:text-left">
							<h3 className="font-heading font-medium text-2xl pb-1">Soziales Engagement</h3>
							<p className="font-sub text-sm">
								Für jeden eingenommen Euro für Reinigung, Pflege und Service spenden wir 5 Cent in den
								Bau von Schulen, für Bildung und Zukunft in der dritten Welt.{' '}
								<a
									target="_blank"
									href="https://www.juergen-hoeller-stiftung.de/"
									className="text-blue-500 underline"
								>
									Mehr erfahren
								</a>
							</p>
						</div>
						<div className="w-full md:w-2/3 text-center md:text-left">
							<h3 className="font-heading font-medium text-2xl pb-1">Geld zurück Garantie</h3>
							<p className="font-sub text-sm">
								Soll­ten unse­re Leis­tun­gen Ihrer Zufrie­den­heit nicht ent­spre­chen, erhal­ten Sie
								Ihr Geld 100% zurück!
							</p>
						</div>
					</div>
				</div>
			</section>
			<div className=" bg-black mt-20 pb-20">
				<div className="flex flex-col mt-6 w-full md:w-1/2 mx-auto mb-6">
					<div>
						<MdFormatQuote className="w-24 h-24 rotate-180  text-gray-300" />
					</div>
					<h4 className="font-heading text-white font-normal text-3xl text-center px-6">
						Unsere Kunden lieben funktionierende und saubere Fenster, Türen und Sonnenschutz - jeden Tag!
					</h4>
					<div className="self-end">
						<MdFormatQuote className="w-24 h-24 text-gray-300" />
					</div>
				</div>
				<div className="max-w-[900px] flex flex-col items-center mx-auto  relative h-96">
					<iframe
						src="https://player.vimeo.com/video/680801973?h=ada8a5a45c&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
						allow="autoplay; fullscreen; picture-in-picture"
						style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
						title="SICCRO active service"
					></iframe>
				</div>
				<script src="https://player.vimeo.com/api/player.js"></script>
			</div>
			<div className="relative w-full pt-20 items-center">
				<Image src={karte} objectFit="contain" height={1000}></Image>
			</div>
			<section className="container mx-auto px-3">
				<h2 className="text-center font-heading font-medium text-5xl py-9">Unsere Services</h2>
				<p className="font-sub text-sm text-center">
					Passende Leistungen, damit Sie Ihren Service individuell zusammenstellen können.
				</p>
				<div className="flex flex-col md:flex-row justify-between md:space-x-12 mt-12">
					<div className="relative w-full md:w-1/3 h-96 my-3">
						<Image src={serviceImage3} layout="fill" objectFit="cover" />
						<div className="absolute w-full h-full flex flex-col justify-between items-center px-3 lg:px-36 py-9 group backdrop-filter backdrop-brightness-50 hover:backdrop-brightness-75 transition-all">
							<h3 className="z-50 font-heading font-black text-4xl text-white">Reinigung</h3>
							<Link href="/reinigung" passHref>
								<button className="border-4 border-solid border-primary text-white w-full p-3 font-semibold rounded-md text-lg group-hover:bg-primary">
									Mehr erfahren
								</button>
							</Link>
						</div>
					</div>
					<div className="relative w-full md:w-1/3 h-96 my-3">
						<Image src={serviceImage1} layout="fill" objectFit="cover" />
						<div className="absolute w-full h-full flex flex-col justify-between items-center px-3 lg:px-36 py-9 group backdrop-filter backdrop-brightness-50 hover:backdrop-brightness-75 transition-all">
							<h3 className="z-50 font-heading font-black text-4xl text-white">Pflege</h3>
							<Link href="/pflege" passHref>
								<button className="border-4 border-solid border-primary text-white w-full p-3 font-semibold rounded-md text-lg group-hover:bg-primary">
									Mehr erfahren
								</button>
							</Link>
						</div>
					</div>
					<div className="relative w-full md:w-1/3 h-96 my-3">
						<Image src={serviceImage2} layout="fill" objectFit="cover" />
						<div className="absolute w-full h-full flex flex-col justify-between items-center px-3 lg:px-36 py-9 group backdrop-filter backdrop-brightness-50 hover:backdrop-brightness-75 transition-all">
							<h3 className="z-50 font-heading font-black text-4xl text-white">Service</h3>
							<Link href="/service" passHref>
								<button className="border-4 border-solid border-primary text-white w-full p-3 font-semibold rounded-md text-lg group-hover:bg-primary">
									Mehr erfahren
								</button>
							</Link>
						</div>
					</div>
				</div>
			</section>
			<section className="relative flex justify-center items-center h-[450px] mt-16">
				<Image src={stock} objectFit="cover" layout="fill" className="backdrop-filter opacity-70" />
				<div className="z-40 px-3 text-center space-y-9 ">
					<h2 className="text-heading text-4xl md:text-6xl font-semibold">Jetzt Angebot erstellen</h2>
					<div className="w-full mx-auto">
						<p className="font-sub font-bold text-base md:text-lg">
							Online konfigurieren, sparen Sie Zeit und haben Sie die perfekte Lösung für einen
							entspannten Alltag.
						</p>
						<div>
							<Link href="/angebot" passHref>
								<button className="rounded-md mt-9 w-full md:w-1/3 select-none font-heading bg-primary p-3 text-white text-lg shadow-md hover:shadow-lg hover:bg-primary-light focus:shadow-sm focus:outline-none active:shadow-inner transition-all active:bg-primary-dark duration-150">
									JETZT ANGEBOT EINHOLEN
								</button>
							</Link>
						</div>
					</div>
				</div>
			</section>
			<footer className="bg-black w-full flex flex-col items-center py-12 px-3">
				<div className="container flex flex-col md:flex-row space-y-6 md:space-y-0">
					<div className="w-full md:w-1/3 items-center flex flex-col">
						<h5 className="text-white text-xl font-bold pb-3">Leistungen</h5>
						<Link href="/reinigung" passHref>
							<a className="text-white py-1 text-sub text-base">Reinigung</a>
						</Link>
						<Link href="/pflege" passHref>
							<a className="text-white py-1 text-sub text-base">Pflege</a>
						</Link>
						<Link href="/service" passHref>
							<a className="text-white py-1 text-sub text-base">Service</a>
						</Link>
					</div>
					<div className="w-full md:w-1/3 items-center flex flex-col">
						<h5 className="text-white text-xl font-bold pb-3">Unternehmen</h5>
						{/* <Link href="/uber-uns" passHref>
								<a className="text-white py-1 text-sub text-base">Über uns</a>
							</Link> */}
						<Link href="/impressum" passHref>
							<a className="text-white py-1 text-sub text-base">Impressum</a>
						</Link>
						<Link href="/agb" passHref>
							<a className="text-white py-1 text-sub text-base">AGB</a>
						</Link>
						<Link href="/datenschutz" passHref>
							<a className="text-white py-1 text-sub text-base">Datenschutz</a>
						</Link>
						<Link href="/cookies" passHref>
							<a className="text-white py-1 text-sub text-base">Cookies</a>
						</Link>
					</div>
					<div className="w-full md:w-1/3 items-center flex flex-col text-white space-y-3">
						<div className="h-20 w-20">
							<Image src={siccro} />
						</div>
						<a href="mailto:kundenservice@siccro.at" className="flex items-center space-x-3">
							<FiMail className="w-6 h-6" />
							<p className="text-base">kundenservice@siccro.at</p>
						</a>
						<a href="tel:0662 27 55 00" className="flex items-center space-x-3">
							<BsTelephone className="w-6 h-6" />
							<p className="text-base">0662 27 55 00</p>
						</a>
						<div className="flex space-x-9 pt-3">
							<a href="https://instagram.com/siccro_active_service" target="_blank">
								<FaInstagram className="w-6 h-6 text-white" />
							</a>
							<a href="https://www.facebook.com/Siccro-Active-Service-109555384717755" target="_blank">
								<FaFacebookSquare className="w-6 h-6 text-blue-500" />
							</a>
						</div>
					</div>
				</div>
				<div className="flex mt-12 space-x-6">
					<div>
						<Image src="/images/payment/sepa.jpg" height="40px" width="80px" objectFit="contain" />
					</div>
					<div>
						<Image src="/images/payment/mastercard.png" height="40px" width="80px" objectFit="contain" />
					</div>
					<div>
						<Image src="/images/payment/visa.jpg" height="40px" width="80px" objectFit="contain" />
					</div>
				</div>
				<p className="text-gray-200 text-center mt-3">
					Alle Rechte vorbehalten. SICCRO® ist eine eingetragene Marke der SYMAK SWISS AG.
				</p>
			</footer>
		</>
	);
};

export default Page;
